'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, Suspense } from 'react';
import { useTranslations } from 'next-intl';
import { useSearchParams, useRouter } from 'next/navigation';
import ContactFormSummerRental from './contact-form-summer-rental';
import ContactFormSummerWorkshop from './contact-form-summer-workshop';
import ContactFormSummerGeneral from './contact-form-summer-general';
import ContactFormWinterRental from './contact-form-winter-rental';
import ContactFormWinterWorkshop from './contact-form-winter-workshop';
import ContactFormWinterGeneral from './contact-form-winter-general';
interface ContactTabsProps {
  season: 'summer' | 'winter';
  locale: string;
}
type TabType = 'rental' | 'workshop' | 'general';
function ContactTabsContent(t0) {
  const $ = _c(46);
  const {
    season,
    locale
  } = t0;
  const searchParams = useSearchParams();
  const router = useRouter();
  const t = useTranslations("ContactTabs");
  const [activeTab, setActiveTab] = useState("rental");
  let t1;
  let t2;
  if ($[0] !== searchParams) {
    t1 = () => {
      const tabParam = searchParams.get("tab") as TabType | null;
      if (tabParam && ["rental", "workshop", "general"].includes(tabParam)) {
        setActiveTab(tabParam);
      }
    };
    t2 = [searchParams];
    $[0] = searchParams;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== router || $[4] !== searchParams) {
    t3 = tab => {
      setActiveTab(tab);
      const params = new URLSearchParams(searchParams.toString());
      params.set("tab", tab);
      router.push(`?${params.toString()}`, {
        scroll: false
      });
    };
    $[3] = router;
    $[4] = searchParams;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleTabChange = t3;
  let t4;
  if ($[6] !== season || $[7] !== t) {
    t4 = season === "summer" ? t("bookRentalSummer") : t("bookRentalWinter");
    $[6] = season;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = {
      id: "rental",
      label: t4
    };
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("bookWorkshop");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = {
      id: "workshop",
      label: t6
    };
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("generalInfo");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = {
      id: "general",
      label: t8
    };
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t5 || $[20] !== t7 || $[21] !== t9) {
    t10 = [t5, t7, t9];
    $[19] = t5;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = t10 as const;
  let t12;
  if ($[23] !== activeTab || $[24] !== handleTabChange || $[25] !== t11) {
    t12 = <div role="tablist" className="flex flex-wrap justify-center gap-2 sm:gap-4 mb-12 border-b-2 border-border">{t11.map(tab_0 => {
        const selected = activeTab === tab_0.id;
        return <button key={tab_0.id} role="tab" id={`contact-tab-${tab_0.id}`} aria-selected={selected} aria-controls={`contact-panel-${tab_0.id}`} onClick={() => handleTabChange(tab_0.id)} className={`px-4 sm:px-8 py-4 text-base sm:text-lg font-bold transition-all relative rounded-t-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary ${selected ? "text-primary border-b-4 border-primary -mb-[2px]" : "text-muted-foreground hover:text-foreground hover:border-b-4 hover:border-muted-foreground/30 -mb-[2px]"}`}>{tab_0.label}</button>;
      })}</div>;
    $[23] = activeTab;
    $[24] = handleTabChange;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== activeTab || $[28] !== locale || $[29] !== season) {
    t13 = activeTab === "rental" && <div role="tabpanel" id="contact-panel-rental" aria-labelledby="contact-tab-rental" tabIndex={0}>{season === "summer" ? <ContactFormSummerRental locale={locale} /> : <ContactFormWinterRental locale={locale} />}</div>;
    $[27] = activeTab;
    $[28] = locale;
    $[29] = season;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== activeTab || $[32] !== locale || $[33] !== season) {
    t14 = activeTab === "workshop" && <div role="tabpanel" id="contact-panel-workshop" aria-labelledby="contact-tab-workshop" tabIndex={0}>{season === "summer" ? <ContactFormSummerWorkshop locale={locale} /> : <ContactFormWinterWorkshop locale={locale} />}</div>;
    $[31] = activeTab;
    $[32] = locale;
    $[33] = season;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== activeTab || $[36] !== locale || $[37] !== season) {
    t15 = activeTab === "general" && <div role="tabpanel" id="contact-panel-general" aria-labelledby="contact-tab-general" tabIndex={0}>{season === "summer" ? <ContactFormSummerGeneral locale={locale} /> : <ContactFormWinterGeneral locale={locale} />}</div>;
    $[35] = activeTab;
    $[36] = locale;
    $[37] = season;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t13 || $[40] !== t14 || $[41] !== t15) {
    t16 = <div className="mt-8">{t13}{t14}{t15}</div>;
    $[39] = t13;
    $[40] = t14;
    $[41] = t15;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t12 || $[44] !== t16) {
    t17 = <div className="w-full">{t12}{t16}</div>;
    $[43] = t12;
    $[44] = t16;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  return t17;
}
export default function ContactTabs(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-full p-8 text-center">Loading...</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Suspense fallback={t0}><ContactTabsContent {...props} /></Suspense>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}